import { useState, useEffect } from 'react'
import { useWireValue } from '@forminator/react-wire'
import * as store from '@store'
import * as actions from '@actions'
import { toast } from 'react-toastify'

const log = new Logger('Payments')

const PurchasesViewModel = () => {
    
    const [error, setError] = useState(null)
    const [loading, setLoading] = useState(false)
    const [purchases, setPurchases] = useState([])
    const [filterMode, setFilterMode] = useState('my-orgs')
    
    const organization = useWireValue(store.currentOrganization)
    
    useEffect(() => {
        
        if (!organization) return
        
        setError(null)
        setLoading(true)
        
        const forOrgId = filterMode === 'current-org'
            ? organization.id
            : undefined
        
        actions.fetchOrgPurchases(forOrgId, filterMode)
            .then(res => setPurchases(res?.purchases ?? []))
            .catch(e => {
                log.e('actions.fetchOrgPurchases() failed', e)
                toast.error('Failed to fetch org purchases')
                setError('Failed to fetch org purchases')
            })
            .finally(() => setLoading(false))
        
    }, [organization, filterMode])
    
    return {
        
        // State
        error,
        loading,
        purchases,
        filterMode,
        setFilterMode,
        
    }
    
}

export default PurchasesViewModel
